import React, { useEffect, useState } from "react";
import { MdDelete } from "react-icons/md";
import { CiEdit } from "react-icons/ci";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { tableCellClasses } from "@mui/material/TableCell";
import s from "./newPuja.module.css";
import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Pagination,
} from "@mui/material";
import { notificationHandler } from "../../utils/Notification";
import Loder from "../../Loder/Loder";
import { BiFilter, BiSearch } from "react-icons/bi";
import DataNotFound from "../ErrorPage/DataNotFound";
import { IoMdAdd } from "react-icons/io";
import {
  deletePuja_api,
  getPujaStatus_api,
  getPuja_api,
} from "../api/newPuja";
import { getBaseUrl2 } from "../../utils";
import { FaEye } from "react-icons/fa";

const NewPujaList = () => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [allPujas, setAllPujas] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [deleteId, setDeleteId] = useState("");
  const [deletePopup, setDeletePopup] = useState(false);
  const [currentPuja, setCurrentPuja] = useState({});
  const [pageLength, setPageLength] = useState();
  const [search, setSearch] = useState("");
  const [eventDate, setEventDate] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  useEffect(() => {
    fetchAllPujasFunc();
  }, [pageCount, search, eventDate, statusFilter]);

  async function fetchAllPujasFunc() {
    setIsLoading(true);
    try {
      const temp = {
        page: pageCount,
        limit: 15,
        search: search.trim(),
        event_date: eventDate,
        status: statusFilter,
      };
      let res = await getPuja_api(temp);
      if (res.data.status) {
        setAllPujas(res?.data?.data?.eventsData);
        setPageLength(res?.data?.data?.total_page);
        setIsLoading(false);
      } else {
        setIsLoading(false);
        console.log("status false!");
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  }

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "var(--clr-theme)",
      color: theme.palette.common.white,
      fontWeight: "bold",
      borderRight: "1px solid #fff",
      overflow: "hidden",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      border: "none",
      borderLeft: "2px solid #00000011",
      "&:last-child": {
        borderRight: "2px solid #00000011",
      },
    },
  }));
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    borderBottom: "2px solid #00000011",
  }));

  async function deletePujaFunc() {
    setIsLoading(true);
    try {
      let res = await deletePuja_api(deleteId);
      if (res.data.status) {
        setIsLoading(false);
        setDeletePopup(false);
        fetchAllPujasFunc();
        notificationHandler({ type: "success", msg: res.data.message });
      } else {
        setIsLoading(false);
        notificationHandler({ type: "danger", msg: res.data.message });
      }
    } catch (error) {
      console.log(error);
      notificationHandler({ type: "danger", msg: error.message });
      setIsLoading(false);
    }
  }

  async function pujaStatusFunc(data) {
    setIsLoading(true);
    try {
      let temp = {
        id: data._id,
        status: data.status === "Active" ? "Inactive" : "Active",
      };
      let res = await getPujaStatus_api(temp);
      if (res?.data?.status) {
        setIsLoading(false);
        fetchAllPujasFunc();
        notificationHandler({ type: "success", msg: res.data.message });
      } else {
        setIsLoading(false);
        notificationHandler({ type: "danger", msg: res.data.message });
      }
    } catch (error) {
      setIsLoading(false);
      notificationHandler({ type: "danger", msg: error.message });
    }
  }

  return (
    <div className="">
      <div className="beat_heading">
        <div className={s["user-list-heading"]}>
          <div className="user-list-title">
            <h3>Puja List</h3>
          </div>
          <div className={s["user-list-search"]}>
            <div className={s["search-box"]}>
              <span style={{ paddingRight: "0.5rem" }}>
                <BiSearch size={23} />
              </span>
              <input
                type="text"
                spellCheck="false"
                onChange={(e) => {
                  setPageCount(1);
                  setSearch(e.target.value);
                }}
                placeholder="Search by name..."
              />
            </div>
            <div className={s["filter-btn"]}>
              <span style={{ paddingRight: "2px" }}>
                <BiFilter size={20} />
              </span>
              Filter
            </div>
          </div>
        </div>
        <div className="beat_left">
          <div
            className={s["title"]}
            onClick={() =>
              navigate("/add-new-puja", {
                state: {
                  pagetype: "Add",
                },
              })
            }
          >
            <IoMdAdd /> Add Puja
          </div>
        </div>
      </div>
      <div className="">
        <div className={s["date_input_box"]}>
          <input
            type="date"
            value={eventDate}
            onChange={(e) => setEventDate(e.target.value)}
          />
          <select onChange={(e) => setStatusFilter(e.target.value)}>
            <option value="">Select Status filter</option>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
        </div>
      </div>
      <div className="beat_table">
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell align="center">Image</StyledTableCell>
              <StyledTableCell align="center">Name</StyledTableCell>
              <StyledTableCell align="center">Location</StyledTableCell>
              <StyledTableCell align="center">Hindi Location</StyledTableCell>
              <StyledTableCell align="center">INR Price</StyledTableCell>
              <StyledTableCell align="center">Status</StyledTableCell>
              <StyledTableCell align="center">Show Date</StyledTableCell>
              <StyledTableCell align="center">Primary God Name</StyledTableCell>
              <StyledTableCell align="center">Purpose</StyledTableCell>
              <StyledTableCell align="center">Priority</StyledTableCell>
              <StyledTableCell align="center">Created</StyledTableCell>
              <StyledTableCell align="center">Action</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {allPujas?.map((row, index) => (
              <StyledTableRow key={row._id}>
                <StyledTableCell>
                  <img
                    src={getBaseUrl2() + row?.thumbnail[0]?.url}
                    alt="thumbnail"
                    style={{ width: "50px", height: "50px" }}
                  />
                </StyledTableCell>
                <StyledTableCell>{row?.name}</StyledTableCell>
                <StyledTableCell>{row?.location}</StyledTableCell>
                <StyledTableCell>{row?.hindiLocation}</StyledTableCell>
                <StyledTableCell>{row?.price}</StyledTableCell>
                <StyledTableCell align="center">
                  <div
                    style={{ cursor: "pointer" }}
                    onClick={() => pujaStatusFunc(row)}
                    className={`${
                      row.status === "Active"
                        ? s.active_admin
                        : s.inactive_admin
                    }`}
                  >
                    {row.status}
                  </div>
                </StyledTableCell>
                <StyledTableCell>{row?.date?.slice(0, 10)}</StyledTableCell>
                <StyledTableCell>{row?.primaryGodName}</StyledTableCell>
                <StyledTableCell>{row?.purpose}</StyledTableCell>
                <StyledTableCell>{row?.priority}</StyledTableCell>
                <StyledTableCell>
                  {row?.created_at?.slice(0, 10)}
                </StyledTableCell>
                <StyledTableCell align="center">
                  <FaEye
                    onClick={() =>
                      navigate(`/view-puja-details`,{
                        state: {
                          pagetype: "Edit",
                          data: row,
                        },
                      })
                    }
                    style={{
                      fontSize: "1rem",
                      color: "var(--clr-primary)",
                      marginRight: "0.5rem",
                      cursor: "pointer",
                    }}
                  />
                  <CiEdit
                    onClick={() =>
                      navigate("/add-new-puja", {
                        state: {
                          pagetype: "Edit",
                          data: row,
                        },
                      })
                    }
                    style={{
                      fontSize: "1rem",
                      color: "var(--clr-primary)",
                      marginRight: "0.5rem",
                      cursor: "pointer",
                    }}
                  />
                  
                  <MdDelete
                    onClick={() => {
                      setDeletePopup(true);
                      setCurrentPuja(row);
                      setDeleteId(row._id);
                    }}
                    style={{
                      fontSize: "1rem",
                      color: "var(--clr-primary)",
                      cursor: "pointer",
                    }}
                  />
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
        {allPujas?.length <= 0 && <DataNotFound />}
        {allPujas?.length > 0 && (
          <div className={s["pagination"]}>
            <Pagination
              count={pageLength}
              size="large"
              style={{ color: "#D21903" }}
              onChange={(e, value) => setPageCount(value)}
              page={pageCount}
            />
          </div>
        )}
      </div>
      <Dialog
        open={deletePopup}
        aria-labelledby="form-dialog-title"
        maxWidth="xs"
        fullWidth="true"
        onClose={() => setDeletePopup(false)}
      >
        <DialogTitle className={s.dialog_title}>
          <div>Do you want to delete {currentPuja.name}?</div>
        </DialogTitle>
        <DialogContent className={s.cardpopup_content}>
          <div style={{ display: "flex", gap: "1rem" }}>
            <div
              className={s.employee_gl_popup}
              onClick={() => setDeletePopup(false)}
            >
              Cancel
            </div>
            <div
              className={s.employee_gl_popup_del}
              onClick={() => deletePujaFunc()}
            >
              Delete
            </div>
          </div>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <Loder loading={isLoading} />
    </div>
  );
};

export default NewPujaList;